import { buildAxiosClient } from '../../../common/models/axiosClient';
import type { AxiosPromise, GenericAbortSignal } from 'axios';
import type { Project } from './project';
import type { ProjectsPrResponse } from './pr';

export default class ProjectClient {
  fetchAll(
    page: number,
    keyword: string | null,
    order: string | null,
    signal?: GenericAbortSignal,
  ): AxiosPromise<Project[]> {
    return buildAxiosClient().get('/api/v1/projects/stagings.json', {
      params: {
        page: page,
        keyword: keyword,
        order: order,
      },
      signal: signal,
    });
  }

  // エンジェル税制対象の募集中案件を先頭から limit 件だけ取る（エンジェル税制シミュレーターの結果下の一覧）。
  // angel_tax=1 は API 側の絞り込み（#17537）。並び順は募集ページ一覧の新着順と同じ。
  fetchAngelTax(
    limit: number,
    signal?: GenericAbortSignal,
  ): AxiosPromise<Project[]> {
    return buildAxiosClient().get('/api/v1/projects/stagings.json', {
      params: {
        angel_tax: 1,
        per_page: limit,
        order: 'in_progress',
      },
      signal: signal,
    });
  }

  fetchPr(signal?: GenericAbortSignal): AxiosPromise<ProjectsPrResponse> {
    return buildAxiosClient().get('/api/v1/projects/pr.json', {
      signal: signal,
    });
  }
}
